import {
  login, runLogoutTimer, saveTokenInLocalStorage, signUp,
  submitProfile, saveProfileInLocalStorage, submitForgotPassword, updateForgotPassword, submitTelegram,
  submitApple, submitGoogle, destroyPhotoProfile, destroyProfile, authorizeAccess
} from '../../services/AuthService';
import { handleAlert, basicHandleError } from "../../services/AlertService";
import { store } from '../store';
import indexedDBService from '../../services/IndexedDBService';
import {
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOADING_TOGGLE_ACTION,
  LOGOUT_ACTION,
  UPDATE_PROFILE_ACTION,
  DELETE_PROFILE_ACTION,
  SWITCH_THEME,
  USER_LOCATION,
  INCREMENT_MAP,
  TOGGLE_WELCOME,
  SET_GROUPED_MODAL_STATE
} from './ActionTypes';

export function signupAction(userParams, history) {
  return (dispatch) => {
    signUp(userParams).then((response) => {
      saveTokenInLocalStorage(Object.assign(response.headers, response));
      runLogoutTimer(dispatch, parseInt(response.headers['expiry']));
      dispatch(confirmedSignupAction(Object.assign(response.headers, response)));
      indexedDBService.getSetting('redirectAfterLogin').then(redirectPath => {
        if (!!redirectPath) { indexedDBService.remove('settings', 'redirectAfterLogin') }
        window.location.href = redirectPath || '/';
      });
    }).catch((error) => {
      basicHandleError(error.response.data.errors.full_messages)
    });
  };
}

export function logout(history) {
  // Clear data from IndexedDB
  indexedDBService.remove('userData', 'userDetails');
  indexedDBService.remove('orders', 'activeOrders');
  if (typeof window.ReactNativeWebView !== 'undefined') {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'LOGOUT' }));
  }
  window.location.href = '/login';
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, history) {
  return (dispatch) => {
    login(email, password).then((response) => {
      saveTokenInLocalStorage(Object.assign(response.headers, response));
      runLogoutTimer(dispatch, parseInt(response.headers['expiry']), history);
      indexedDBService.getUserData('userDetails').then(async tokenDetails => {
        dispatch(loginConfirmedAction(tokenDetails));
        const redirectPath = await indexedDBService.getSetting('redirectAfterLogin');
        if (!!redirectPath) { indexedDBService.remove('settings', 'redirectAfterLogin') }
        window.location.href = redirectPath || response.data.path || '/';
      });
    }).catch((error) => {
      basicHandleError(error.response.data.errors)
    });
  };
}

export function submitProfileAction(profile, history) {
  return (dispatch) => {
    submitProfile(profile)
      .then((response) => {
        saveProfileInLocalStorage(response.data.profile, response.data.restaurants);
        dispatch(updateProfileCompleteAction(response.data.profile, response.data.restaurants));
        handleAlert('success', 'Gotovo', 'Профіль змінено')
      })
      .catch((error) => {
        basicHandleError(error.response.data.errors);
      });
  };
}

export function switchThemeAction(theme) {
  return {
    type: SWITCH_THEME,
    payload: theme,
  };
}

export function incrementMapKey() {
  return {
    type: INCREMENT_MAP,
    TOGGLE_WELCOME,
    SET_GROUPED_MODAL_STATE
  };
}

export function destroyPhotoProfileAction() {
  return (dispatch) => {
    destroyPhotoProfile()
      .then((response) => {
        saveProfileInLocalStorage(response.data.profile);
        dispatch(updateProfileCompleteAction(response.data.profile));
        handleAlert('success', 'Gotovo', 'Профіль змінено')
      })
      .catch((error) => {
        basicHandleError(error.response.data.errors);
      });
  };
}

export function deleteProfileAction(history) {
  return (dispatch) => {
    destroyProfile().catch(() => {
      logout(history);
      // Clear all data from IndexedDB
      indexedDBService.clear('userData');
      indexedDBService.clear('orders');
      indexedDBService.clear('settings');
      indexedDBService.clear('notifications');
      dispatch(deleteProfileCompleteAction());
      basicHandleError(['Профіль Gotovo видалено']);
    });
  }
}

export function submitTelegramAction(telegram, history) {
  return (dispatch) => {
    submitTelegram(telegram).then((resp) => {
      saveProfileInLocalStorage(resp.data.user);
      dispatch(updateProfileCompleteAction(resp.data.user));
      window.location.href = history.location.pathname;
    }).catch((error) => {
      basicHandleError(error.response.data.errors);
    });
  };
}

export function submitAppleAction(idToken, history) {
  return (dispatch) => {
    submitApple(idToken).then((resp) => {
      saveProfileInLocalStorage(resp.data.user);
      dispatch(updateProfileCompleteAction(resp.data.user));
      window.location.href = history.location.pathname;
    }).catch((error) => {
      basicHandleError(error.response.data.errors);
    });
  };
}

export function submitGoogleAction(idToken, history) {
  return (dispatch) => {
    submitGoogle(idToken).then((resp) => {
      saveProfileInLocalStorage(resp.data.user);
      dispatch(updateProfileCompleteAction(resp.data.user));
      window.location.href = history.location.pathname;
    }).catch((error) => {
      basicHandleError(error.response.data.errors);
    });
  };
}

export function submitForgotPasswordAction(profile, history) {
  return () => {
    submitForgotPassword(profile)
      .then(() => {
        history.push("/login");
        handleAlert('success', 'Gotovo', 'Тепер відкрийте свою пошту і натисніть на посилання')
      })
      .catch((error) => {
        basicHandleError(error.response.data.errors);
      });
  };
}

export function updateForgotPasswordAction(profile, history) {
  return () => {
    updateForgotPassword({
      password: profile.password, password_confirmation: profile.password_confirmation,
      reset_password_token: history.location.search.split('=')[1]
    })
      .then(() => {
        history.push("/login");
        handleAlert('success', 'Gotovo', 'Тепер ви можете зайти по новому паролю')
      })
      .catch((error) => {
        basicHandleError(error.response.data.errors.full_messages);
      });
  };
}

export function authorizeAccessAction(history) {
  return (dispatch) => {
    authorizeAccess().then((response) => {
      saveTokenInLocalStorage(Object.assign(response.headers, response));
      runLogoutTimer(dispatch, parseInt(response.headers['expiry']), history);
      // Get user details from IndexedDB
      indexedDBService.getUserData('userDetails').then(tokenDetails => {
        dispatch(loginConfirmedAction(tokenDetails));
        window.location.href = response.data.path || '/dashboard';
      });
    }).catch((error) => {
      basicHandleError(error.response.data.errors);
    });
  };
}

export function changeUserLocation(location) {
  const auth = store.getState().auth.auth;
  if (!!auth.idToken) {
    return (dispatch) => {
      let params = {};
      if (!!auth.userData?.delivery_point?.lat) {
        params['latitude'] = location.lat;
        params['longitude'] = location.lng;
      } else {
        params['latitude'] = location.lat;
        params['longitude'] = location.lng;
        params['delivery_point'] = location
      }
      submitProfile(params).then((response) => {
        saveProfileInLocalStorage(response.data.profile);
        dispatch(updateProfileCompleteAction(response.data.profile));
      })
    }
  } else {
    return {
      type: USER_LOCATION,
      payload: location,
    };
  }
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

export function updateProfileCompleteAction(user, restaurants) {
  return {
    type: UPDATE_PROFILE_ACTION,
    payload: user,
    restaurants: restaurants
  };
}

export function deleteProfileCompleteAction() {
  return {
    type: DELETE_PROFILE_ACTION
  };
}
export function toggleWelcomeAction(showWelcome) {
  return {
    type: TOGGLE_WELCOME,
    SET_GROUPED_MODAL_STATE,
    payload: showWelcome,
  };
}

export function setGroupedModalStateAction(payload) {
  return {
    type: SET_GROUPED_MODAL_STATE,
    payload,
  };
}
